import { Component, Prop } from '@stencil/core';

/**
 * @description Adds variable vertical space between content areas. Configurable by responsive breakpoint.
 * @use
 * @ssh
 * @since 4.0.0
 * @version 2
 */
@Component({
  tag: 'hp6-spacing-vertical',
  styleUrl: 'spacing-vertical.scss',
  shadow: false, // Already satisfies the single-tag policy without shadow DOM
})
export class SpacingVertical {
  /**
   * The `hp-themes` spacing size of this spacing at `xsmall` breakpoint and up
   */
  @Prop({ reflect: true }) xs: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | null | 'null' | 0;

  /**
   * The `hp-themes` spacing size of this spacing at `small` breakpoint and up
   */
  @Prop({ reflect: true }) sm: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | null | 'null' | 0;

  /**
   * The `hp-themes` spacing size of this spacing at `medium` breakpoint and up
   */
  @Prop({ reflect: true }) md: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | null | 'null' | 0;

  /**
   * The `hp-themes` spacing size of this spacing at `large` breakpoint
   */
  @Prop({ reflect: true }) lg: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | null | 'null' | 0;
}
